<template>
  <div v-if="store.alert.show">
    <div
      :class="
        store.alert.status === 'success' ? 'alert-success' : 'alert-danger'
      "
      class="alert alert-dismissible fade show message-alert"
      role="alert"
    >
      <span class="font-weight-bold">{{ store.alert.message }}</span>

      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
      >
        <span aria-hidden="true" class="la la-close"></span>
      </button>
    </div>
  </div>
</template>
<script setup>
import { useGlobalStore } from "@/store/modules/global";
const store = useGlobalStore();
</script>
<style lang="scss">
.message-alert {
  position: fixed;
  max-width: 100%;
  width: 100%;
  top: 0px;
  z-index: 1100;
}
</style>
